import type { Artwork } from "@design-lab/shared/types/artwork";

export type Bounds = {
  minWidthInches: number;
  minHeightInches: number;
  maxWidthInches: number;
  maxHeightInches: number;
};

// Derive bounds from artwork metadata similarly to Vue store fields
export function calculateTransferBounds(artwork?: Artwork | undefined): Bounds | undefined {
  if (!artwork || !artwork.metadata) return undefined;
  const meta: any = (artwork as any).metadata;

  // Default to 1 inch minimums to match Vue transfers constraints when explicit min values are absent
  const minWidthInches = Number(meta?.minWidth || meta?.minWidthInch || 1) || 1;
  const minHeightInches = Number(meta?.minHeight || meta?.minHeightInch || 1) || 1;
  // Prefer sheet bounds over image-specific bounds to match Vue behavior
  const maxWidthInches = Number(meta?.maxSheetWidth || meta?.maxWidth || 0) || 0;
  const maxHeightInches = Number(meta?.maxSheetHeight || meta?.maxHeight || 0) || 0;

  if (maxWidthInches <= 0 || maxHeightInches <= 0) return undefined;

  return {
    minWidthInches,
    minHeightInches,
    maxWidthInches,
    maxHeightInches
  };
}
